<template>
  <div class="animated fadeIn py3">
    <div class="clearfix gibson px2 mb2">
      <haandvaerker></haandvaerker>
      <div class="col-12 px0" v-if="showMobile">
        <div class="clearfix mt3 mb3">
          <div class="col-12 gibson">
            <p class="h4 semi-bold line-height-2 my2 darkblue">Få anbefalingsbannere til din hjemmeside</p>
            <p class="h5 regular darkblue line-height-golden mb3">
              Med anbefalingsbannerne tiltrækker du nye kunder, fordi de kan se, at dine tidligere kunder er tilfredse.<br />
              <span class="semi-bold block">Sådan gør du:</span>
              <ul class="list-reset my2 px0" style="list-style-type: square;list-style-position: inside;">
                <li class="px2 my1 h5 regular line-height-golden">Kopiér teksten ved at trykke på den grønne knap herunder</li>
                <li class="px2 my1 h5 regular line-height-golden">Send teksten til den person, som har lavet din hjemmeside og bed vedkommende sætte banneret på din hjemmeside</li>
              </ul>
            </p>
          </div>
        </div>
        <div class="clearfix mt2" v-if="haaId !== '0'">
          <div class="col-12 mb2 px0">
            <div class="">
              <div class="clearfix px0">
                <div class="col-12 px2 darkblue gibson">
                  <p class="h4 mt3 semi-bold line-height-2 mt3 mb2">Banner med anbefalinger</p>
                  <p class="h5 regular darkblue line-height-golden">
                    Du kan indsætte dette banner, som viser antal anbefalinger og din gennemsnitlige anbefalingsscore.
                  </p>
                  <collectreviews></collectreviews>
                </div>
                <div class="col-12 px0">
                  <b-collapse visible id="collapse5">
                    <ratingWidget :items="items" :ratingwidget="ratingwidget"></ratingWidget>
                  </b-collapse>
                </div>
              </div>
            </div>
          </div>
          <div class="col-12 mb2 px0">
            <div class="clearfix px0">
              <div class="col-12 px2 darkblue gibson">
                <p class="h4 mt3 semi-bold line-height-2 my2">Banner med udtalelser fra kunder</p>
                <p class="h5 regular line-height-golden">
                  Du kan også indsætte dette banner, som viser udtalelser fra dine kunder.
                </p>
              </div>
              <div class="col-12 p2">
                <b-collapse visible id="collapse6">
                  <commentWidget :items="items" :commentwidget="commentwidget"></commentWidget>
                </b-collapse>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-12 pl4 px0" v-if="!showMobile">
        <div class="clearfix mt3 mb3 pl4">
          <div class="col-6 gibson">
            <p class="h3 semi-bold line-height-2 my2 darkblue">Få anbefalingsbannere til din hjemmeside</p>
            <p class="h5 regular darkblue line-height-golden mb3">
              Med anbefalingsbannerne tiltrækker du nye kunder, fordi de kan se, at dine tidligere kunder er tilfredse.<br />
              Bannerne kan hjælpe dig til at blive placeret bedre på Google <br /><br />
              Sådan får du dit anbefalingsbanner på din egen hjemmeside. <br />
              <span class="semi-bold block">Sådan gør du:</span>
              <ul class="list-reset my2 px0" style="list-style-type: square;list-style-position: inside;">
                <li class="px2 my1 h5 regular line-height-golden">Kopiér teksten ved at trykke på den grønne knap herunder</li>
                <li class="px2 my1 h5 regular line-height-golden mb3">Send teksten til den person, som har lavet din hjemmeside og bed vedkommende sætte banneret på din hjemmeside</li>
              </ul>
            </p>
          </div>
        </div>
        <div class="clearfix flex items-stretch mt2 pl4" v-if="haaId !== '0'">
          <div class="col col-4 mr2 mb2 px0 items-stretch">
            <div class="">
              <div class="clearfix px0">
                <div class="col-12 px2">
                  <p class="h4 mt3 semi-bold line-height-2 mt3 mb2 darkblue">Banner med anbefalinger</p>
                  <p class="h5 regular darkblue line-height-golden mb3">
                    Du kan indsætte dette banner, som viser antal anbefalinger og din gennemsnitlige anbefalingsscore.
                  </p>
                  <collectreviews></collectreviews>
                </div>
                <div class="col-12 px0">
                  <b-collapse visible id="collapse5">
                    <ratingWidget :items="items" :ratingwidget="ratingwidget"></ratingWidget>
                  </b-collapse>
                </div>
              </div>
            </div>
          </div>
          <div class="col col-4 mb2 px0 items-stretch">
            <div class="clearfix px0">
              <div class="col-12 px2">
                <p class="h4 mt3 semi-bold line-height-2 my2 darkblue">Banner med udtalelser fra kunder</p>
                <p class="h5 regular darkblue line-height-golden">
                  Du kan også indsætte dette banner, som viser udtalelser fra dine kunder.
                </p>
              </div>
              <div class="col-12 p2">
                <b-collapse visible id="collapse6" class="mt2">
                  <commentWidget :items="items" :commentwidget="commentwidget"></commentWidget>
                </b-collapse>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="py4"></div>
  </div>
</template>
<script>
import Haandvaerker from './haandvaerker'
import ratingWidget from './ratingWidget'
import commentWidget from './commentWidget'
export default {
  name: 'widgets',
  components: {
    Haandvaerker,
    ratingWidget,
    commentWidget
    // collectreviews,
    // reviews,
    // ImageRating
  },
  data () {
    return {
      show: false,
      label: 'Loading...',
      overlay: 1,
      salesPerson: '',
      haaId: '',
      ratingwidget: '',
      commentwidget: '',
      items: [],
      images: [],
      showMobile: false
    }
  },
  created () {
    this.Reload()
  },
  methods: {
    Reload () {
      this.show = true
      this.salesPerson = localStorage.getItem('id_token_portal')
      this.haaId = localStorage.getItem('haaid')
      var data = {operation: 'oversigt_partner_haa', salesPerson: this.salesPerson, levid: this.haaId}
      this.$http.post('', data, { emulateJSON: true })
        .then(
          response => {
            var res = response.body
            this.show = false
            if (res.login === false) {
              this.$router.push('/login')
            }
            this.items = res
            this.ratingwidget = res.ratingwidget
            this.commentwidget = res.commentwidget
          },
          response => {
            alert('error')
          }
        )
    }
  }
}
</script>



// WEBPACK FOOTER //
// Widgets.vue?44636f2c